import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement } from 'lit/decorators.js';
import componentStyles from './ghs-featured-grid.css.lit';
import '../../base/outline-container/outline-container';

/**
 * The GhsFeaturedGrid component
 * @element ghs-featured-grid
 * @slot - default slot
 */
@customElement('ghs-featured-grid')
export class GhsFeaturedGrid extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  render(): TemplateResult {
    return html`
      <div class="featured-grid">
        <slot></slot>
      </div>
    `;
  }
}
